import React from 'react';
import { FormattedMessage } from 'react-intl';
import featureImg1 from '../Images/land-finding-img1.png';
import featureImg2 from '../Images/land-finding-img2.png';
import { PrimaryButton } from '../../../components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { createResourceLocatorString } from '../../../util/routes';
import routeConfiguration from '../../../routing/routeConfiguration';
import css from './Sections.module.css';

function FeatureSection() {
  const history = useHistory();
  const redirectToTrustedSuppliers = () => {
    history.push(createResourceLocatorString('TrustedSuppliersPage', routeConfiguration(), {}, {}));
  };

  return (
    <div className={css.featureSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.featureInfo}>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg1} alt="" />
            </div>
            <div className={css.featureDetails}>
              <h3>
                <FormattedMessage id="FinancePage.FeatureSection.selfBuildTitle" />
              </h3>
              <p>
                <FormattedMessage id="FinancePage.FeatureSection.selfBuildDescription" />
              </p>
              <PrimaryButton
                className={css.trustedSupplierBtn}
                type="button"
                onClick={redirectToTrustedSuppliers}
              >
                <FormattedMessage id="FinancePage.FeatureSection.button" />
              </PrimaryButton>
            </div>
          </div>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg2} alt="" style={{ objectFit: 'contain' }} />
            </div>
            <div className={css.featureDetails}>
              <h3>
                <FormattedMessage id="FinancePage.FeatureSection.developerTitle" />
              </h3>
              <p>
                <FormattedMessage id="FinancePage.FeatureSection.developerDescription" />
              </p>
              <PrimaryButton
                className={css.trustedSupplierBtn}
                type="button"
                onClick={redirectToTrustedSuppliers}
              >
                <FormattedMessage id="FinancePage.FeatureSection.button" />
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeatureSection;
